import { render, staticRenderFns } from "./brandBuilding.vue?vue&type=template&id=ada1efec&scoped=true"
import script from "./brandBuilding.vue?vue&type=script&lang=js"
export * from "./brandBuilding.vue?vue&type=script&lang=js"
import style0 from "./brandBuilding.vue?vue&type=style&index=0&id=ada1efec&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada1efec",
  null
  
)

export default component.exports